/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The EventsControllerDtoEventStarterPackInfoDetailResponse model module.
 * @module model/EventsControllerDtoEventStarterPackInfoDetailResponse
 * @version 1.0
 */
class EventsControllerDtoEventStarterPackInfoDetailResponse {
    /**
     * Constructs a new <code>EventsControllerDtoEventStarterPackInfoDetailResponse</code>.
     * @alias module:model/EventsControllerDtoEventStarterPackInfoDetailResponse
     */
    constructor() { 
        
        EventsControllerDtoEventStarterPackInfoDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventStarterPackInfoDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventStarterPackInfoDetailResponse} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventStarterPackInfoDetailResponse} The populated <code>EventsControllerDtoEventStarterPackInfoDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventStarterPackInfoDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('walletAddress')) {
                obj['walletAddress'] = ApiClient.convertToType(data['walletAddress'], 'String');
            }
            if (data.hasOwnProperty('depositAmount')) {
                obj['depositAmount'] = ApiClient.convertToType(data['depositAmount'], 'Number');
            }
            if (data.hasOwnProperty('packNo')) {
                obj['packNo'] = ApiClient.convertToType(data['packNo'], 'Number');
            }
            if (data.hasOwnProperty('regDuration')) {
                obj['regDuration'] = ApiClient.convertToType(data['regDuration'], 'Number');
            }
            if (data.hasOwnProperty('needUsedPower')) {
                obj['needUsedPower'] = ApiClient.convertToType(data['needUsedPower'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('rewardXper')) {
                obj['rewardXper'] = ApiClient.convertToType(data['rewardXper'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem1')) {
                obj['rewardItem1'] = ApiClient.convertToType(data['rewardItem1'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem1Count')) {
                obj['rewardItem1Count'] = ApiClient.convertToType(data['rewardItem1Count'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem2')) {
                obj['rewardItem2'] = ApiClient.convertToType(data['rewardItem2'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem2Count')) {
                obj['rewardItem2Count'] = ApiClient.convertToType(data['rewardItem2Count'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem3')) {
                obj['rewardItem3'] = ApiClient.convertToType(data['rewardItem3'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem3Count')) {
                obj['rewardItem3Count'] = ApiClient.convertToType(data['rewardItem3Count'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('walletNo')) {
                obj['walletNo'] = ApiClient.convertToType(data['walletNo'], 'Number');
            }
            if (data.hasOwnProperty('initialXper')) {
                obj['initialXper'] = ApiClient.convertToType(data['initialXper'], 'Number');
            }
            if (data.hasOwnProperty('balanceXper')) {
                obj['balanceXper'] = ApiClient.convertToType(data['balanceXper'], 'Number');
            }
            if (data.hasOwnProperty('depositTransactionStatus')) {
                obj['depositTransactionStatus'] = ApiClient.convertToType(data['depositTransactionStatus'], 'Number');
            }
            if (data.hasOwnProperty('xperUsed')) {
                obj['xperUsed'] = ApiClient.convertToType(data['xperUsed'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventStarterPackInfoDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventStarterPackInfoDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['walletAddress'] && !(typeof data['walletAddress'] === 'string' || data['walletAddress'] instanceof String)) {
            throw new Error("Expected the field `walletAddress` to be a primitive type in the JSON string but got " + data['walletAddress']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {String} walletAddress
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['walletAddress'] = undefined;

/**
 * @member {Number} depositAmount
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['depositAmount'] = undefined;

/**
 * @member {Number} packNo
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['packNo'] = undefined;

/**
 * @member {Number} regDuration
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['regDuration'] = undefined;

/**
 * @member {Number} needUsedPower
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['needUsedPower'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['endAt'] = undefined;

/**
 * @member {Number} rewardXper
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['rewardXper'] = undefined;

/**
 * @member {Number} rewardItem1
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['rewardItem1'] = undefined;

/**
 * @member {Number} rewardItem1Count
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['rewardItem1Count'] = undefined;

/**
 * @member {Number} rewardItem2
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['rewardItem2'] = undefined;

/**
 * @member {Number} rewardItem2Count
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['rewardItem2Count'] = undefined;

/**
 * @member {Number} rewardItem3
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['rewardItem3'] = undefined;

/**
 * @member {Number} rewardItem3Count
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['rewardItem3Count'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['createdAt'] = undefined;

/**
 * @member {Number} walletNo
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['walletNo'] = undefined;

/**
 * @member {Number} initialXper
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['initialXper'] = undefined;

/**
 * @member {Number} balanceXper
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['balanceXper'] = undefined;

/**
 * @member {Number} depositTransactionStatus
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['depositTransactionStatus'] = undefined;

/**
 * @member {Number} xperUsed
 */
EventsControllerDtoEventStarterPackInfoDetailResponse.prototype['xperUsed'] = undefined;






export default EventsControllerDtoEventStarterPackInfoDetailResponse;

